<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3CB043" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap pt-8 pb-10 justify-center>
      <v-flex xs11 sm11 pt-10 text-left>
        <!-- Wishlist Title -->
        <v-layout wrap pt-16>
          <v-flex xs12 pl-2>
            <span
              style="
                color: #000000;
                font-family: poppinssemibold;
                font-size: 25px;
              "
            >
              Wishlist
            </span>
          </v-flex>
        </v-layout>
    
        <!-- Back to EcoShop Icon and Text (below Wishlist) -->
        <v-layout wrap pt-4>
          <v-flex xs12 pl-2 d-flex align-center>
            <router-link :to="'/ecoShop?shopname=' + 'All'+ '&id=' + ''">
            <v-icon 
              small
              class="mr-2"
              style="cursor: pointer; color: green;"
            >
              mdi-arrow-left
            </v-icon>
            <span
              style="
                color: green;
                font-family: poppinsregular;
                font-size: 16px;
                cursor: pointer;
              "
            >
              Back to EcoShop
            </span>
          </router-link>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
    <v-layout wrap justify-center>
      <v-flex
        xs12
        sm12
        md12
        lg11
        px-2
        px-xs-2
        px-sm-2
        px-md-2
        px-lg-0
        px-xl-0
        v-if="wishlist"
      >
        <v-layout wrap justify-start>
          <v-flex
            xs12
            sm6
            md3
            px-3
            pb-16
            v-for="(list, l) in wishlist"
            :key="l"
          >
            <v-card elevation="0">
                <v-layout wrap justify-center pb-8>
                  <v-flex xs12>
                    <v-layout wrap justify-center>
                      <v-flex
                        xs12
                        pt-6
                      >
                        <v-flex xs11 sm11 md11 pl-15 align-self-center>
                          <v-layout wrap justify-end align-center fill-height>
                            <v-flex xs2 align-self-center>
                        
                                <v-layout wrap py-1  @click="removeWishlist(list)">
                                  <v-flex>
                                    <v-icon size="20px" color="red"
                                      >mdi-heart</v-icon
                                    >
                                  </v-flex>
                                </v-layout>
                      
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-img
                          contain
                          height="160px"
                          :src="mediaURL + list.productImage[0]"
                        ></v-img>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
            </v-card>
            <v-layout wrap justify-start>
              <v-flex xs12>
                <router-link
                :to="
                '/productDetails?productName=' +
                list.productName +
                '&id=' +
                list.productId
              "
              >
                <v-layout wrap px-2>
                  <!-- <v-flex xs12>
                                <span
                                  style="
                                    color: #bcb4b4;
                                    font-family: poppinsmedium;
                                    font-size: 12px;
                                  "
                                  >{{ list.name }}</span
                                >
                              </v-flex> -->
                  <v-flex xs9 sm6 md8 text-left pt-2>
                    <span
                      style="
                        color: #000000;
                        font-family: poppinsmedium;
                        font-size: 15px;
                        text-transform: capitalize;
                      "
                      >{{ list.productName.slice(0, 15) }}</span
                    >
                    <span v-if="list.productName.length > 15"> ... </span>
                  </v-flex>
                  <v-flex xs3 sm6 md4 pt-2 text-right>
                    <span
                      style="
                        color: #000000;
                        font-family: RobotoBold;
                        font-size: 17px;
                      "
                    >
                      {{ list.productPrice }}</span
                    >
                  </v-flex>
                  <v-flex xs12 text-left>
                    <span
                      style="
                        color: #000000;
                        font-family: poppinsmedium;
                        font-size: 14px;
                      "
                      >{{ list.productSize }}</span
                    >
                  </v-flex>
                  <v-flex xs12 text-left>
                    <span style="color: #F28F34; font-size: 13px; font-family: poppinssemibold">
                      Sold by : 
                      <span style="color: #191919; font-size: 13px; font-family: poppinsmedium">
                        {{ list.shopname }}
                      </span>
                    </span>
                  </v-flex>
                  <v-flex xs12 text-left>
                    <v-layout wrap justify-start>
                      <v-flex xs4 sm4 md6 lg4>
                        <v-rating
                          hover
                          length="5"
                          size="18"
                          background-color="#F28F34"
                          color="#F28F34"
                          half-increments
                          readonly
                          v-model="list.productRating"
                        ></v-rating>
                      </v-flex>
                      <v-flex xs4 sm4 md6 lg8 text-left>
                        <span
                          style="
                            color: #2b2b2b;
                            font-family: poppinslight;
                            font-size: 12px;
                          "
                          >({{ list.reviewCount }})</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 text-left pt-3>
                    <v-btn
                     v-if="list.isCart==false"
                      color="#1D9A50"
                      dark
                      elevation="0"
                      rounded
                      :to="
                        '/productDetails?productName=' +
                        list.productName +
                        '&id=' +
                        list.productId
                      "
                    >
                      <span
                        style="
                          font-family: opensansbold;
                          text-transform: none;
                          font-size: 13px;
                          letter-spacing: 0px;
                        "
                        >Add to Cart</span
                      ></v-btn
                    >
                    <v-btn 
                                v-else
                                color="grey"
                                dark
                                elevation="0"
                                rounded
                              >
                                <span
                                  style="
                                    font-family: opensansbold;
                                    text-transform: none;
                                    font-size: 13px;
                                    letter-spacing: 0px;
                                  "
                                >
                                  In Cart
                                </span>
                              </v-btn>
                  </v-flex>
                </v-layout>
              </router-link>

              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- <v-layout wrap justify-center pt-2>
                  <v-flex xs12>
                    <div class="text-center pb-5" v-if="pages > 1">
                      <v-pagination
                        :length="pages"
                        :total-visible="7"
                        v-model="currentPage"
                        color="#30B868"
                        circle
                      ></v-pagination>
                    </div>
                  </v-flex>
                </v-layout> -->
      </v-flex>
      <v-flex xs12 v-else pb-16>
        <v-layout wrap justify-center align-center>
          <v-flex xs12 class="text-center">
            <span class="nodata">Your wishlist is empty !</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["relatedProducts"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      wishlist: [],
    
    };
  },
  computed: {
    appLogin() {
      if (this.$store.state.isLoggedIn) return this.$store.state.isLoggedIn;
      else return null;
    },
    appUserId() {
      return this.$store.state.id;
    },
    UserId() {
      return this.$store.state.userId;
    },
  },
  beforeMount() {
    this.getWishlist();
  },
  methods: {
    getWishlist() {
      this.appLoading = true;
      // if (this.appLogin) {
      //   headers1 = {
      //     token: localStorage.getItem("token"),
      //   };
      // } else {
      //   headers1 = {
      //     guestId: localStorage.getItem("userId"),
      //   };
      // }
      axios({
        url: "/user/wishlist/list",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          customerId:localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
          productId: this.$route.query.id,
        },
      })
        .then((response) => {
          if(response.data){
            this.appLoading = false;
          this.wishlist = response.data.wishlistData;
          this.$store.commit("changeWishlist", response.data.wishListCount);
          }
         else{
          this.appLoading=false
         }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    removeWishlist(item) {
      this.appLoading = true;
      axios({
        url: "/user/wishList/Add",
        method: "POST",
        data: {
          productId: item.productId,
          customerId:localStorage.getItem("id"),
          
          guestId: localStorage.getItem("userId"),
        },
        // headers: {
        //   token: localStorage.getItem("token"),
        // },
      })
        .then((response) => {
          this.appLoading = false;
          this.product = response.data.data;
          this.$store.commit("changeWishlist", response.data.wishListCount);
          this.catId = "";
          this.getWishlist();
          this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>